import { Outlet, Navigate } from "react-router";
import { useAuth } from "../context/AuthContext";

function PrivateRoutes() {
  const { isAuthenticated } = useAuth();
  return isAuthenticated === null ? (
    <div></div>
  ) : isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to={"/login"} />
  );
}

export default PrivateRoutes;
